import ErrorBoundary from '@/components/ErrorBoundary'
import { routes } from '@/App'
import { lazy, Suspense } from 'react'
import { useRoutes } from 'react-router-dom'

const AdminOrders = lazy(() => import('@/pages/AdminOrders'))

function AdminFallback() {
  return (
    <div className="min-h-screen bg-zinc-950 flex items-center justify-center">
      <p className="text-sm text-stone-400 tracking-wide">載入中...</p>
    </div>
  )
}

function ClientApp() {
  const element = useRoutes([
    ...routes,
    {
      path: '/admin',
      element: (
        <ErrorBoundary>
          <Suspense fallback={<AdminFallback />}>
            <AdminOrders />
          </Suspense>
        </ErrorBoundary>
      ),
    },
  ])

  return (
    <ErrorBoundary>
      {element}
    </ErrorBoundary>
  )
}

export default ClientApp
